module.exports = __webpack_public_path__ + "img/489.63234903.jpg";